<script setup lang="ts">
import { LazyModalSupportTicket } from "#components";

const { trackEvent } = useGAnalytics();
const { openModal } = useModalManager();

const openSupportTicket = () => {
  trackEvent("support_chat");
  openModal({
    id: "modal-support-ticket",
    component: LazyModalSupportTicket,
  });
};
</script>

<template>
  <div
    data-test="button-help-chat"
    class="fixed w-max bottom-3 sm:bottom-20 right-4 sm:right-6 rounded-full bg-neutral-200 cursor-pointer z-10 flex items-center justify-center"
    @click="openSupportTicket">
    <NuxtIcon
      name="mdi:conversation"
      class="w-6 h-6 sm:w-8 sm:h-8 m-2 text-primary-900"
      :alt="$t('main.imageAltTexts.supportIcon')" />
  </div>
</template>
